import classNames from 'classnames';

const Label = ({
	className,
	children,
	...props
}: React.LabelHTMLAttributes<HTMLLabelElement>) => (
	<label
		className={classNames('text-sm text-gray-label', className)}
		{...props}
	>
		{children}
	</label>
);

export default Label;
